import React from "react";
import { LoaderProvider } from "./ViewHooks/LoaderHook";
import GlobalStyles from "./Styles/global";
import { Rotas } from "./Routes/index.routes";
import { UsuarioProvider } from "./Hooks/UsuarioHook";
import { ResponseProvider } from "./ViewHooks/Response";
import { AlertProvider } from "./ViewHooks/AlertHook";

function App() {
  return (
    <LoaderProvider>
      <ResponseProvider>
        <AlertProvider>
          <UsuarioProvider>
            <div className="App">
              <GlobalStyles />

              <Rotas />
            </div>
          </UsuarioProvider>
        </AlertProvider>
      </ResponseProvider>
    </LoaderProvider>
  );
}

export default App;
